import * as React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { ProductContentsSectionHeaderProps } from 'lib/themes/themes';
import pacificBaseStyles from 'components/Themes/Pacific/base.module.css';

const ProductContentsSectionHeader = ({
  stylizedText,
  text,
}: ProductContentsSectionHeaderProps) => {
  const { i18n } = useTranslation();

  return (
    <h2
      className={clsx(
        'base-single__section__title',
        pacificBaseStyles['base-single__section__title'],
        pacificBaseStyles['pacific'],
        pacificBaseStyles['semi-big-text']
      )}
    >
      {stylizedText}
      {i18n.language !== 'en-US' && (
        <span className={pacificBaseStyles['base-single__section__title_jp']}>{text}</span>
      )}
    </h2>
  );
};

export default ProductContentsSectionHeader;
